import Vue from 'vue';
import moment from 'moment';
import { chain } from 'lodash';
import i18n from '@/i18n';
import Breadcrumbs from '@/router/breadcrumbs';
import { mapState } from 'vuex';

Vue.mixin({
  data() {
    return {
      Breadcrumbs,
      unsubscribeMutations: null
    };
  },
  computed: {
    ...mapState(['Project', 'Account']),
    isDeveloper() {
      return this.Account.active.data.developer;
    },
    maskTimeData() {
      const { settings } = this.Project.active.data;

      if (this.isDeveloper) return false;

      return settings ? settings.mask_time_data || false : false;
    },
    userProjectSettingsKey() {
      return `${this.accountID}-${this.Project.active.data.id}-settings`;
    },
    accountID() {
      return JSON.parse(localStorage.getItem('account') || '{}').id;
    }
  },
  // Uygulamanin genelinde store'u izleyen (subscribe olan) genelde created hook'u icinde fonksiyonlar vardir.
  // Component tekrar aktif oldugunda bir onceki subscribe olan fonksiyonun calismamasi icin unsubscribeMutations cagirilir.
  beforeDestroy() {
    if (this.unsubscribeMutations) {
      this.unsubscribeMutations();
    }
  },
  methods: {
    normalizeDate(date, format = 'MMM D, YYYY HH:mm') {
      if (!date) return '-';
      moment.locale(i18n.locale);

      return moment(date).format(format);
    },
    normalizeString(name, normalize = true) {
      try {
        if (this.$te(name)) {
          return this.$t(name);
        }
      } catch (err) {
        console.warn(`${name} was not normalized`);
      }

      if (normalize) {
        return chain(name)
          .startCase()
          .value();
      }

      return name;
    },
    maskableTime(date) {
      if (this.maskTimeData) return this.normalizeDate(date, 'MMM D, YYYY');

      return this.normalizeDate(date);
    },
    convertToServerTimeZone(date, format = 'YYYY-MM-DD HH:mm:ss', removeTimeZone = false) {
      const timezoneOffset = new Date().getTimezoneOffset();
      let d = date;

      if (removeTimeZone) d = moment(date).add(new Date(d).getTimezoneOffset(), 'minutes').format(format);

      return moment(d, format).add(timezoneOffset, 'minutes').format(format);
    },
    convertToLocalTimeZone(date, format = 'YYYY-MM-DD HH:mm:ss') {
      const timezoneOffset = new Date().getTimezoneOffset();

      return moment(date, format).subtract(timezoneOffset, 'minutes').format(format);
    },
    onImgError(e) {
      // eslint-disable-next-line no-param-reassign
      e.target.src = '/statics/erased_image.png';
      // eslint-disable-next-line no-param-reassign
      e.target.onerror = '';

      return true;
    },
    userProjectSettings() {
      return JSON.parse(localStorage.getItem(this.userProjectSettingsKey) || '{}');
    }
  }
});
